var React = require('react');

function ProfilesIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 8a1 1 0 0 1 1-1h2.17a3.001 3.001 0 0 1 5.66 0H25a1 1 0 1 1 0 2H14.83a3.001 3.001 0 0 1-5.66 0H7a1 1 0 0 1-1-1zM7 15a1 1 0 1 0 0 2h6.17a3.001 3.001 0 0 0 5.66 0H25a1 1 0 1 0 0-2h-6.17a3.001 3.001 0 0 0-5.66 0H7zM6 24a1 1 0 0 1 1-1h2.17a3.001 3.001 0 0 1 5.66 0H25a1 1 0 1 1 0 2H14.83a3.001 3.001 0 0 1-5.66 0H7a1 1 0 0 1-1-1z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 0a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6zm0 2a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6z","fill":"#fff","key":1})]);
}

ProfilesIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ProfilesIcon;

ProfilesIcon.default = ProfilesIcon;
